export function getShortLoadFieldName(field: string) {
  return field.replace('formattedData.loads.', '')
}
